import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Heart } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { play, unlockAudio } from "@/lib/sfx";

const CLAP = ["jump", "winkwave", "star", "winkwave"];

export const Applause = () => {
  const { t } = useI18n();
  const [show, setShow] = useState(0);
  const [frame, setFrame] = useState(0);
  const timers = useRef([]);

  useEffect(() => {
    const onApplause = () => {
      unlockAudio();
      play("clap");
      timers.current.forEach(clearTimeout);
      timers.current = [];
      setShow(Date.now());
      for (let i = 1; i <= 10; i += 1) timers.current.push(setTimeout(() => setFrame(i), i * 160));
      timers.current.push(setTimeout(() => setShow(0), 2200));
    };
    window.addEventListener("ananawi-applause", onApplause);
    const pending = timers.current;
    return () => {
      window.removeEventListener("ananawi-applause", onApplause);
      pending.forEach(clearTimeout);
    };
  }, []);

  return (
    <AnimatePresence>
      {show ? (
        <motion.div
          key="applause"
          initial={{ y: 220, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 220, opacity: 0 }}
          transition={{ type: "spring", stiffness: 260, damping: 18 }}
          className="fixed z-[72] bottom-0 inset-x-0 mx-auto w-fit pointer-events-none flex flex-col items-center"
          data-testid="applause-mascot"
        >
          {Array.from({ length: 8 }).map((_, i) => (
            <motion.span
              key={`${show}-${i}`}
              className="absolute bottom-24 left-1/2"
              initial={{ x: 0, y: 0, opacity: 1, scale: 0.6 }}
              animate={{ x: (i - 3.5) * 34, y: -160 - (i % 3) * 40, opacity: 0, scale: 1.2 }}
              transition={{ duration: 1.6, delay: i * 0.08 }}
            >
              <Heart className="w-7 h-7 -ml-3.5 fill-pink text-pink" />
            </motion.span>
          ))}
          <span className="mb-2 rounded-full sticker-sm bg-white px-4 py-1.5 font-display font-semibold text-base">{t.gallery.thanks}</span>
          <motion.img
            src={`/brand/${CLAP[frame % CLAP.length]}.webp`}
            alt=""
            className="w-36 sm:w-44 h-auto"
            animate={{ rotate: frame % 2 ? 6 : -6, y: frame % 2 ? -10 : 0 }}
            transition={{ duration: 0.15 }}
          />
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};
